import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  private get storage(): Storage | null {
    return typeof window !== 'undefined' ? window.localStorage : null;
  }

  setItem(key: string, value: string): void {
    this.storage?.setItem(key, value);
  }

  getItem(key: string): string | null {
    return this.storage?.getItem(key) ?? null;
  }

  removeItem(key: string): void {
    this.storage?.removeItem(key);
  }

  clear(): void {
    this.storage?.clear();
  }

  setObject<T>(key: string, value: T): void {
    this.setItem(key, JSON.stringify(value));
  }

  getObject<T>(key: string): T | null {
    const raw = this.getItem(key);
    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  }
}

